import { forPhoneOnly } from 'src/config/mediaQueries'
import { createUseStyles } from 'react-jss'
import { typography } from '@dentalux/ui-library-core'
import { shadows } from 'src/config/styles'
import { Theme } from '@mui/material/styles'

const BODY_WIDTH = 682

export default createUseStyles((theme: Theme) => ({
  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: BODY_WIDTH,
    [forPhoneOnly]: {
      flexDirection: 'column-reverse',
    },
  },
  primaryCta: {
    whiteSpace: 'nowrap',
    marginLeft: 16,
    [forPhoneOnly]: {
      marginLeft: 0,
      marginBottom: 10,
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: BODY_WIDTH,
    margin: '0 auto',
    [forPhoneOnly]: {
      padding: [0, 16, 16, 16],
    },
  },
  bodyHeadline: {
    ...typography['Lato Body 1'],
    textAlign: 'center',
    margin: [24, 0],
    [forPhoneOnly]: {
      marginTop: 0,
      marginBottom: 24,
    },
  },
  tilesContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  tile: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '24px 16px',
    background: theme.palette.common.white,
    boxShadow: shadows[3],
    borderRadius: 8,
    width: '100%',
    alignSelf: 'stretch',
    [forPhoneOnly]: {
      padding: '16px 8px',
    },
  },
  tileIcon: {
    width: 67,
    height: 65,
    marginBottom: 32,
    [forPhoneOnly]: {
      marginBottom: 16,
      width: 32,
      height: 32,
    },
  },
  noFilter: {
    filter: 'none',
  },
  treatmentName: {
    ...typography['Lato H5 Bold'],
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 2'],
    },
  },
  badge: {
    position: 'absolute',
    right: 0,
    top: 10,
    ...typography['Lato Caption Bold'],
    color: theme.palette.grey[900],
    padding: '8px 4px',
    background: theme.palette.secondary[200],
    borderRadius: '4px 0 0 4px',
    [forPhoneOnly]: {
      padding: '4px 2px',
      ...typography['Lato Caption Small Bold'],
    },
  },
  plusIcon: {
    margin: '0 20px',
    width: 48,
    height: 48,
    [forPhoneOnly]: {
      margin: '0 8px',
      width: 24,
      height: 24,
    },
  },
  advantageContainer: {
    boxShadow: shadows[3],
    padding: '16px 24px',
    background: theme.palette.common.white,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    [forPhoneOnly]: {
      padding: '8px 16px 24px 16px',
      borderRadius: 6,
    },
  },
  advantageHeadline: {
    ...typography['Lato H5 Bold'],
    marginBottom: 16,

    [forPhoneOnly]: {
      ...typography['Lato Emphasized 1'],
    },
  },
  advantage: {
    display: 'flex',
    marginBottom: 24,
  },
  advantageText: {
    marginLeft: 8,
    ...typography['Lato Body 1'],
    [forPhoneOnly]: {
      ...typography['Lato Body 2'],
    },
  },
  divider: {
    width: '100%',
    height: 1,
    background: theme.palette.grey[300],
    marginBottom: 24,
  },
  disclaimerText: {
    ...typography['Lato Caption Small'],
  },
}))
